import { useParams, useNavigate, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSeasons, getMainPageData } from '@severed-links/common.redherrings-reducers/terminator'
export default function useTerminatorAdminSeason() {
  const params = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const { seasons, seasonId: activeSeason, seasonMode, week, playoffWeek } = useSelector(state => state.terminator)
  const [selected, selectLocalSeason] = useState('')
  const destination = pathname.split('/')[3]
  const routed = ['register-players', 'payments', 'manual-entry', 'reminder-log'].includes(destination)
  const phase = params.seasonMode ? (params.seasonMode.toLowerCase() === 'postseason' ? 'Postseason' : 'Regular') : seasonMode === 'Postseason' ? 'Postseason' : 'Regular'
  const currentWeek = params.playoffWeek || params.week || (phase === 'Postseason' ? playoffWeek : week) || 1
  // An explicit unknown season must never silently select the active season.
  const seasonId = params.seasonName ? seasons.find(season => season.seasonName === params.seasonName)?.seasonId || '' : selected || activeSeason || ''
  const season = seasons.find(item => item.seasonId === seasonId)
  const pathFor = (name, nextPhase = phase, nextWeek = currentWeek) => {
    const base = `/terminator/admin/${destination}`
    const encoded = encodeURIComponent(name)
    if (destination === 'manual-entry') return `${base}/${encoded}/${nextPhase}/${nextPhase === 'Postseason' ? 'playoff-week' : 'week'}/${nextWeek}`
    if (destination === 'reminder-log') return `${base}/season/${encoded}/${nextPhase.toLowerCase()}/week/${nextWeek}`
    return `${base}/${encoded}`
  }
  const setSelected = id => {
    const next = seasons.find(item => item.seasonId === id)
    if (routed && next) navigate(pathFor(next.seasonName))
    else selectLocalSeason(id)
  }
  const setPickWindow = (nextPhase, nextWeek) => {
    if (season && Number.isInteger(Number(nextWeek)) && Number(nextWeek) > 0) navigate(pathFor(season.seasonName, nextPhase, Number(nextWeek)))
  }
  useEffect(() => { dispatch(getSeasons()); dispatch(getMainPageData()) }, [dispatch])
  useEffect(() => {
    if (routed && season && (!params.seasonName || (destination === 'manual-entry' && (!params.seasonMode || !params.week && !params.playoffWeek)))) {
      navigate(pathFor(season.seasonName), { replace: true })
    }
  }, [routed, season, destination, params.seasonName, params.seasonMode, params.week, params.playoffWeek, phase, currentWeek, navigate])
  return { dispatch, seasons, seasonId, setSelected, initialPhase: phase, initialWeek: currentWeek, setPickWindow }
}
